import React, { useEffect, useState } from 'react';
import LayoutDesktop from './LayoutDesktop';
import LayoutMobile from './LayoutMobile';

const Layout = ({ children }) => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    
  }, []);

  return isDesktop ? (
    <LayoutDesktop>{children}</LayoutDesktop>
  ) : (
    <LayoutMobile>{children}</LayoutMobile>
  );
};

export default Layout;